import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getSelects = store => store[NAME].selects;
export const getStartHolidaysOnNonWorkingDay = store => store[NAME].startHolidaysOnNonWorkingDay;
export const getAllowHalfDayHolidays = store => store[NAME].allowHalfDayHolidays;
export const getAdditionalLegalDays = store => store[NAME].additionalLegalDays;
export const getHasSignedDocument = store => store[NAME].hasSignedDocument;